<template>
  <div class="modal fade" id="changeOnboardingModal" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content content">
        <div class="modal-header">
          <a type="button" class="close-btn" data-dismiss="modal">
            <ion-icon name="close"></ion-icon>
          </a>
          <div class="title-group">
            <h4 class="title-modal">Alterar status de onboarding</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="body-status">
            <div class="modal-body-content-input">
              <input type="radio" class="trial" name="name" value="0" disabled v-on:click="valueOnboarding(0)"/>
              <input type="radio" class="onboarding" name="name" value="1" v-on:click="valueOnboarding(1)"/>
              <input type="radio" class="middle" name="name" value="2" v-on:click="valueOnboarding(2)"/>
              <input type="radio" class="ongoing" name="name" value="3" v-on:click="valueOnboarding(3)"/>
            </div>
            <div class="modal-body-content-span">
              <span class="span-trial">Trial</span>
              <span class="span-onboarding">Onboarding</span>
              <span class="span-mid">Mid</span>
              <span class="span-ongoing">Ongoing</span>
            </div>
            <textarea class="textarea-content" id="txtareaOnboarding" placeholder="Adicionar observações"/>
          </div>
          <a class="btn-change" v-on:click="setNewStatus()">
            <span v-if="!loadingSend">Alterar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </a>
        </div>

        <!--          <div class="body-csat">-->
        <!--            <div v-if="valueCurrent !== 0 || valueCurrentFunnel !== 0">-->
        <!--              <span v-if="linkGeneratedCSAT" class="btn-generate-link" @click="generateLinkCSAT()">-->
        <!--              <span class="btn-group-link" v-if="!loadingLinkCSAT">-->
        <!--                <ion-icon name="link-outline"></ion-icon>-->
        <!--                <span v-if="valueCurrentFunnel === 1">Gerar link de CSAT - Onboarding</span>-->
        <!--                <span v-else-if="valueCurrentFunnel === 2">Gerar link de CSAT - Mid</span>-->
        <!--                <span v-else-if="valueCurrentFunnel === 3">Gerar link de CSAT - Ongoing</span>-->
        <!--                <span v-else>Gerar link de CSAT - Trial</span>-->
        <!--              </span>-->
        <!--              <span class="btn-group-link" v-else>-->
        <!--                <div class="loading-btn button-loading">-->
        <!--                  <div class="spinner-btn button-spinner">-->
        <!--                    <div class="rect1"></div>-->
        <!--                    <div class="rect2"></div>-->
        <!--                    <div class="rect3"></div>-->
        <!--                    <div class="rect4"></div>-->
        <!--                    <div class="rect5"></div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </span>-->
        <!--            </span>-->
        <!--              <div v-else class="body-link">-->
        <!--              <span class="btn-generated">-->
        <!--                <ion-icon name="checkmark-circle-outline"></ion-icon>-->
        <!--                Link gerado!-->
        <!--              </span>-->
        <!--                <span class="generated-text">-->
        <!--                O cliente precisará estar logado no Painel Administrativo para responder à pesquisa.-->
        <!--              </span>-->
        <!--                <span class="generated-link">-->
        <!--                {{ linkCSAT }}-->
        <!--              </span>-->
        <!--                <span class="generated-copy"-->
        <!--                      @click="copyLink(linkCSAT)">-->
        <!--                <ion-icon name="link-outline"></ion-icon>-->
        <!--                Copiar link&nbsp;-->
        <!--              </span>-->
        <!--                <span v-if="copied" class="generated-copied">Link copiado!</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
      </div>
    </div>
  </div>
</template>

<script>

import {CHANGE_JOURNEY_ONBOARDING, CREATE_NOTE_FUNNEL, GET_LINK_CSAT} from "../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../requestConfig";
import swal from "sweetalert";
import {ALERT_SERVICE} from "../../../msgAlertService";

export default {
  name: "modalChangeOnboarding",
  props: {
    userIdFunnel: '',
    dataUserNameFunnel: '',
    valueCurrent: '',
    oldStatus: '',
    companyIdFunnel: '',
    companyContextFunnel: '',
    ownerActualFunnel: '',
    runFunction: {
      type: Function,
    },
  },
  data() {
    return {
      loadingSend: false,
      valueCurrentFunnel: '',
      linkGeneratedCSAT: true,
      copied: false,
      loadingLinkCSAT: false,
      linkCSAT: '',
    }
  },
  methods: {
    generateLinkCSAT() {
      this.loadingLinkCSAT = true;

      let obj = {
        companyId: this.companyIdFunnel,
        userResponsible: this.ownerActualFunnel,
        journey: this.valueCurrentFunnel + 1
      }

      REQUEST_SERVICE.post(GET_LINK_CSAT, obj).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LINK_CSAT:", response.data);

        this.linkCSAT = response.data.link
        this.linkGeneratedCSAT = false;
        this.loadingLinkCSAT = false;
      }).catch((reason) => {
        this.loadingLinkCSAT = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    setChecked(val) {

      this.valueCurrentFunnel = val

      switch (this.valueCurrentFunnel) {
        case 0:
          $('.trial').attr('checked', true)
          break;
        case 1:
          $('.onboarding').attr('checked', true)
          break;
        case 2:
          $('.middle').attr('checked', true)
          break;
        case 3:
          $('.ongoing').attr('checked', true)
          break;
        default:
          console.log(`error!!`);
      }
    },
    valueOnboarding(value) {
      this.valueCurrentFunnel = value
    },
    setNewStatus() {
      this.loadingSend = true;

      let url = CHANGE_JOURNEY_ONBOARDING;
      url += "/" + this.$props.companyIdFunnel
      url += "/" + this.valueCurrentFunnel

      REQUEST_SERVICE.requestContext("GET", url, this.$props.companyContextFunnel)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_JOURNEY_ONBOARDING:", response.data);

          this.runFunction();
          this.addObs();

        })
        .catch((reason) => {

          this.loadingSend = false;
          $('#changeOnboardingModal').modal('hide');
          swal("Aviso", 'Erro!', "error");

        });
    },
    addObs() {

      const txt = document.getElementById('txtareaOnboarding').value;
      const str = txt.replaceAll("\n", "<br>")
      const type = 14
      const oldStatsValue = this.$props.oldStatus
      const currentStatsValue = this.valueCurrentFunnel

      let newStr = ''

      let nameOldStatsValue = ''
      let nameCurrentStatusValue = ''

      if (oldStatsValue === 0) {
        nameOldStatsValue = 'TRIAL'
      }
      if (oldStatsValue === 1) {
        nameOldStatsValue = 'ONBOARDING'
      }
      if (oldStatsValue === 2) {
        nameOldStatsValue = 'MID'
      }
      if (oldStatsValue === 3) {
        nameOldStatsValue = 'ONGOING'
      }

      if (currentStatsValue === 0) {
        nameCurrentStatusValue = 'TRIAL'
      }
      if (currentStatsValue === 1) {
        nameCurrentStatusValue = 'ONBOARDING'
      }
      if (currentStatsValue === 2) {
        nameCurrentStatusValue = 'MID'
      }
      if (currentStatsValue === 3) {
        nameCurrentStatusValue = 'ONGOING'
      }

      if (str === '') {
        newStr = `<p><strong style="color: rgb(136, 136, 136);"><em>Alterado de</em> ${nameOldStatsValue} <em>para </em>${nameCurrentStatusValue}</strong></p>`
      } else {
        newStr = str + `<br><br><p><strong style="color: rgb(136, 136, 136);"><em>Alterado de</em> ${nameOldStatsValue} <em>para </em>${nameCurrentStatusValue}</strong></p>`
      }

      let obj = {
        userId: this.$props.userIdFunnel,
        userName: this.$props.dataUserNameFunnel,
        pipelineId: this.$route.params.idPipe,
        pipelineBusinessId: this.$route.params.idBusiness,
        businessNoteType: type,
        text: newStr
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.post(CREATE_NOTE_FUNNEL, obj).then((response) => {
        UTIL_SERVICE.console("RESULT CREATE_NOTE_FUNNEL:", response.data);

        this.loadingSend = false;
        $('#changeOnboardingModal').modal('hide');
        swal("Aviso", response.data, "success");

      }).catch((reason) => {

        this.loadingSend = false;
        $('#changeOnboardingModal').modal('hide');
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    copyLink(link) {
      navigator.clipboard.writeText(link)
      this.copied = true
    }
  },
  watch: {
    valueCurrent: function (val) {
      this.setChecked(val);
    },
    valueCurrentFunnel: function (newValue, oldValue) {
      this.linkGeneratedCSAT = true;
    }
  },
}
</script>

<style lang="scss" scoped>

#changeOnboardingModal {
  .modal-dialog {
    width: 689px;
    margin-top: 15%;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;

      .modal-header {
        position: relative;
        padding: 20px 30px;
        border-bottom: none;

        .title-group {
          display: flex;
          align-items: flex-end;
          padding-bottom: 10px;
          border-bottom: 1px solid #E6E9EC;

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }

          .title-modal {
            margin: 0;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);
          }
        }

        .subtitle {
          span {
            margin-top: 5px;
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .close-btn {
          position: absolute;
          right: 26px;
          top: 16px;
          height: 20px;
          color: var(--light-red);

          &:hover {
            color: var(--high-red);
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0 30px 20px;

        .body-status {
          display: flex;
          margin-bottom: 5px;

          .textarea-content {
            position: absolute;
            top: 0;
            right: 30px;
            height: 100px;
            width: 320px;
            max-width: 320px !important;
            max-height: 100px !important;
            padding: 5px 10px;
            resize: none;
            transition: .2s;

            border-radius: 8px !important;
            border: 1px solid #BFC7D4;

            &:focus {
              border-color: var(--high-blue);
              outline: none;
            }

            &:hover {
              border-color: var(--high-blue);
            }
          }

          .modal-body-content-input {
            display: flex;
            flex-direction: column;

            input {
              -webkit-appearance: none;
              display: block;
              margin: 0 0 15px 0;
              width: 24px;
              height: 24px;
              border-radius: 12px !important;
              cursor: pointer;
              vertical-align: middle;
              box-shadow: rgba(126, 141, 167, 0.5) 0 1px 1px, inset rgba(126, 141, 167, 0.5) 0 0 0 1px;
              background-color: var(--classic-white);
              background-image: -webkit-radial-gradient(var(--high-blue) 0%, var(--high-blue) 33%, var(--classic-white) 40%, var(--classic-white) 70%);
              background-repeat: no-repeat;
              -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
              -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
              outline: none;
            }

            input:checked {
              -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
              -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
            }

            input:disabled {
              background-color: var(--classic-gray);
              cursor: no-drop;
            }

            input:active {
              -webkit-transform: scale(1.5);
              -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
            }


            /* The up/down direction logic */

            input,
            input:active {
              background-position: 0 24px;
            }

            input:checked {
              background-position: 0 0;
            }

            input:checked ~ input,
            input:checked ~ input:active {
              background-position: 0 -24px;
            }
          }

          .modal-body-content-span {
            display: flex;
            flex-direction: column;

            span {
              font-size: 16px;
              font-weight: 400;
            }

            .span-trial {
              margin: 2px 0 10px 10px;
            }

            .span-onboarding {
              margin: 6px 0 10px 10px;
            }

            .span-mid {
              margin: 6px 0 10px 10px;
            }

            .span-ongoing {
              margin: 6px 0 10px 10px;
            }
          }
        }

        .btn-change {
          position: absolute;
          bottom: 20px;
          right: 30px;
          text-decoration: none;
          background: var(--high-blue);
          padding: 9px 30px;
          color: var(--classic-white);
          border-radius: 4px !important;

          &:hover {
            background: #20179E;
          }
        }

        .body-csat {
          position: relative;

          .btn-generate-link {
            .btn-group-link {
              display: flex;
              align-items: center;
              width: max-content;
              font-weight: 400;
              font-size: 14px;
              color: #2F23D6;
              border: 1px solid #2F23D6;
              border-radius: 4px !important;
              padding: 10px 20px;
              transition: .2s;
              cursor: pointer;

              &:hover {
                color: #FFFFFF;
                background: #2F23D6;

                .button-loading {
                  .button-spinner {
                    > div {
                      background-color: #FFFFFF;
                    }
                  }
                }
              }

              ion-icon {
                font-size: 20px;
                margin-right: 6px;
              }

              .button-loading {
                .button-spinner {
                  > div {
                    margin-top: 3px;
                    background-color: #2F23D6;
                  }
                }
              }
            }
          }

          .body-link {
            .btn-generated {
              display: flex;
              align-items: center;
              width: max-content;
              font-weight: 400;
              font-size: 14px;
              color: #2ACC6B;
              padding: 10px 20px;
              border: 1px solid #2ACC6B;
              border-radius: 4px !important;
              transition: .2s;
              cursor: pointer;
              margin-bottom: 10px;

              ion-icon {
                font-size: 20px;
                margin-right: 6px;
              }
            }

            .generated-text {
              font-weight: 400;
              font-size: 14px;
              color: #191919;
            }

            .generated-link {
              font-weight: 400;
              font-size: 14px;
              line-height: 30px;
              color: #7F8897;
            }

            .generated-copy {
              display: flex;
              align-items: center;
              width: max-content;
              font-weight: 400;
              font-size: 14px;
              color: #2F23D6;
              transition: .2s;
              cursor: pointer;
              border-bottom: 1px solid transparent;

              &:hover {
                color: #352DA5;
                border-bottom: 1px solid #352DA5;
              }

              ion-icon {
                font-size: 20px;
                margin-right: 6px;
              }
            }

            .generated-copied {
              position: absolute;
              bottom: 1.5px;
              left: 110px;
              font-size: 11px;
              color: #FF445D;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeOnboarding.vue